export default {
  state: {
    supplierDialogVisible: false,
    currentSupplier: {
      priceReceiveMethod: "api",
    },
    tabs: [],
    mainSupplier: null,
    supplierActiveTab: null,
  },
  getters: {
    isSupplierDialogVisible: (state) => {
      return state.supplierDialogVisible;
    },
    currentSupplier: (state) => {
      return state.currentSupplier;
    },
    tabs: (state) => {
      return state.tabs;
    },
    mainSupplier: (state) => {
      return state.mainSupplier;
    },
    supplierActiveTab: (state) => {
      return state.supplierActiveTab;
    },
  },
  mutations: {
    updateSupplierDialogVisible(state, value) {
      state.supplierDialogVisible = value;
    },
    updateCurrentSupplier(state, value) {
      state.currentSupplier = value;
    },
    updatemainSupplier(state, value) {
      state.mainSupplier = value;
    },
    updateSupplierActiveTab(state, value) {
      state.supplierActiveTab = value;
    },
  },
};
